!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.dayjs_plugin_localeData = e();
}(this, function () {
  "use strict";

  return function (t, e, n) {
    var r = function r(t, e, n, _r) {
      var o = t.$locale();
      return o[e] ? o[e] : o[n].map(function (t) {
        return t.substr(0, _r);
      });
    };

    e.prototype.localeData = function () {
      return function () {
        var t = this;
        return {
          months: function months(e) {
            return e ? e.format("MMMM") : r(t, "months");
          },
          monthsShort: function monthsShort(e) {
            return e ? e.format("MMM") : r(t, "monthsShort", "months", 3);
          },
          firstDayOfWeek: function firstDayOfWeek() {
            return t.$locale().weekStart || 0;
          },
          weekdaysMin: function weekdaysMin(e) {
            return e ? e.format("dd") : r(t, "weekdaysMin", "weekdays", 2);
          },
          weekdaysShort: function weekdaysShort(e) {
            return e ? e.format("ddd") : r(t, "weekdaysShort", "weekdays", 3);
          }
        };
      }.bind(this)();
    }, n.localeData = function () {
      var t = n.Ls[n.locale()];
      return {
        firstDayOfWeek: function firstDayOfWeek() {
          return t.weekStart || 0;
        }
      };
    };
  };
});